export function isMacOS() {
  return navigator.userAgent.includes('Mac OS');
}
